import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { replaceHighlights } from 'global/helpers/highlights'
import type { FaqCategory, TheHulkMessageProps } from 'modules/TheHulk/TheHulk.types'
import type { ReactElement } from 'react'

export interface FaqQuestionProps {
  readonly faqQuestions: TheHulkMessageProps[] | null
  readonly selectedCategory: FaqCategory
  readonly searchTerm?: string
}

const FaqQuestionCard = ({ faqQuestions, selectedCategory, searchTerm }: FaqQuestionProps): ReactElement => {

  return (<Grid container
    p={2}
    sx={{
      width: '100%',
      gap: 2,
    }}
  >
    <Box>
      <Typography variant="h4" color="primary.main">
        {selectedCategory?.name}
      </Typography>
      <Typography variant="p3" color="primary.main">
        {selectedCategory?.description}
      </Typography>
    </Box>
    {faqQuestions?.map((question) => (
      <Grid key={question.key} size={12}>
        <Accordion defaultExpanded>
          <AccordionSummary aria-controls="panel1d-content" id="panel1d-header"
            expandIcon={<ExpandMoreIcon sx={{ color: 'primary.main' }} />}
            sx={{ flexDirection: 'row-reverse' }}>
            <Typography variant="h6" color="primary.main">
              {searchTerm ? replaceHighlights(question.title, [searchTerm]) : question.title}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="p3" component="p" color="primary.main" pl={2}>
              {searchTerm ? replaceHighlights(question.content, [searchTerm]) : question.content}
            </Typography>
          </AccordionDetails>
        </Accordion>
      </Grid>
    ))}
  </Grid>)

}

export default FaqQuestionCard